import React from 'react';

const PHASES = [
  {
    weeks: 'Weeks 1–12',
    title: 'Foundations',
    desc: 'The fundamentals that still matter, in the right order — and what you can safely skip.',
  },
  {
    weeks: 'Weeks 13–40',
    title: 'Ship real things',
    desc: 'Move from tutorials to working full-stack apps, using AI to learn and build faster.',
  },
  {
    weeks: 'Weeks 41–72',
    title: 'Own your domain',
    desc: 'Go deep on a part of the stack, take real ownership, and start being trusted with hard problems.',
  },
  {
    weeks: 'Weeks 73–100',
    title: 'Genuinely valuable',
    desc: 'Become the developer employers fight to keep — and know exactly why.',
  },
];

export default function F2FRoadmap() {
  return (
    <section className="f2f-roadmap-v2">
      <div className="wrap">
        <p className="f2f-roadmap-eyebrow">A preview of the map</p>
        <h2 className="f2f-roadmap-heading">The first 100 weeks, in four phases.</h2>
        <p className="f2f-roadmap-sub">
          You'll leave with the full week-by-week version. Here's the shape of the journey we'll map together.
        </p>

        <div className="f2f-roadmap-cards">
          {PHASES.map((phase) => (
            <div key={phase.weeks} className="f2f-roadmap-card">
              <span className="f2f-roadmap-weeks">{phase.weeks}</span>
              <h3 className="f2f-roadmap-card-title">{phase.title}</h3>
              <p className="f2f-roadmap-card-desc">{phase.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
